import * as d3 from 'd3';
import React, { useEffect } from 'react';

function PIP (props) {

    const pos = props.pos,
        chr = props.chr,
        size = props.size,
        elements = props.elements,
        scalePosition = props.scalePosition,
        biobanks = props.biobanks,
        PIPs = props.PIPs,
        format = props.format,
        drawPosition = props.drawPosition,
        generateLocus = props.generateLocus,
        finemapping = props.finemapping;
    
    useEffect(()=>{

        d3.select("#pips02")
            .selectAll('.pip')
            .data(biobanks)
            .join('g')
                .attr('class', 'pip')
                .attr('id', (d, i) => `pip02_${i}`)
                .style("transform", (d, i) => `translateY(${(i*size.height+size.margin.top+size.genes)}px)`)

        biobanks.forEach((bb, n)=>{

            const data = elements.filter(el => format('pp', el[PIPs[n]]) !== '–')
            
            d3.select(`#pip02_${n}`)
                .selectAll(".unit")
                .data(data, d => d)
                .join(
                    function(enter){
                        enter.append('circle')
                            .attr('key', (d,i) => i)
                            .attr('class', 'unit')
                            .attr('r', 4)
                            .attr('cy', size.height/2)
                            .attr('fill', 'white')
                            .style('opacity', 1)
                            .on('mouseover', function(e,d) {
                                d3.select('#hoverLine02')
                                    .style('display', 'block')
                                    .attr('x1', scalePosition(d[pos]))
                                    .attr('x2', scalePosition(d[pos]));
                            })
                            .on('click', (e, d) => {generateLocus(d[chr], d[pos]); drawPosition(d[pos])})
                            .transition().duration(500)
                                .attr('cx', d => scalePosition(d[pos]))
                    },
                    function(update){
                        update
                            .on('mouseover', function(e,d) {
                                d3.select('#hoverLine02')
                                    .style('display', 'block')
                                    .attr('x1', scalePosition(d[pos]))
                                    .attr('x2', scalePosition(d[pos]));
                            })
                            .on('click', (e, d) => {generateLocus(d[chr], d[pos]); drawPosition(d[pos])})
                            .transition().duration(500)
                                .attr('cx', d => format('pp', d[PIPs[n]]) === '–' ? -200 : scalePosition(d[pos]))
                    },
                    function(exit){
                        exit.transition().duration(500).style('opacity', 0)
                            .transition().remove()
                    }
                )

            });

    })

    return (
        <g 
            id="pips02" 
            style={{
                opacity: finemapping ? 1 : 0,
                pointerEvents: finemapping ? 'auto' : 'none'
            }}
        />
    )
    
}
export default PIP;